"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enrichSnowplowEvent = exports.DEFAULT_SCHEMA = void 0;
const string_transform_1 = require("../utils/string-transform");
exports.DEFAULT_SCHEMA = 'iglu:com.wetransfer/ad_event/jsonschema/2-0-0';
const enrichSnowplowEvent = (payload, state) => {
    const { category, label, action, value, version, client, product, placement, application, } = payload;
    const { flightId, creativeId, adId, priorityId, campaignId, impressionId, sourceUrl, } = payload.creative;
    const { user, auth, siteId } = state;
    return {
        product,
        siteId,
        category,
        label: label ? (0, string_transform_1.stringTransform)(label) : undefined,
        action,
        value,
        version,
        client,
        flightId,
        creativeId,
        adId,
        priorityId,
        campaignId,
        creativeUrl: sourceUrl ? (0, string_transform_1.stringTransform)(sourceUrl) : undefined,
        impressionId,
        userId: (user === null || user === void 0 ? void 0 : user.id) || null,
        auth0Id: (auth === null || auth === void 0 ? void 0 : auth.auth0UserId) || null,
        placement,
        application,
    };
};
exports.enrichSnowplowEvent = enrichSnowplowEvent;
//# sourceMappingURL=snowplow.js.map